import React, { useState, useEffect } from 'react';
import './App.css';
import Dashboard from './components/Dashboard/Dashboard';
import LoadingPage from './components/LoadingPage/LoadingPage';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoaded(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <ErrorBoundary>
      <div className="App">
        {loaded ? <Dashboard /> : <LoadingPage />}
      </div>
    </ErrorBoundary>
  );
}

export default App;